define([
	"dojo/_base/declare",
	"csi/action/_NewCommentMixin",
	"csi/action/ManageController",
	"csi/html",
	"csi/reflection",
	"csi/table",
	"csi/xml",
	"csi/heading/StringRich"
], function(declare, _NewCommentMixin, ManageController, html, reflection, table, xml) {

	return declare([ManageController, _NewCommentMixin], {
		bRichRefNode: true,

		constructor: function() {
			// summary: add manage action parameters so manage controller will work as normal
			this.m_action.compositeId = "CommentRow";
			this.m_urlNode = xml.nodeGetAttributeValue(this.getParent(), this.m_action.compositeId);
			this.m_bToggle = xml.isValidURL(this.m_urlNode);

			// determine concrete class for comment row
			var rc = reflection.getNodeClass(this.getParent());
			var rcr = rc.getRelation(this.m_action.compositeId, true);
			this.m_action.compositeClass = rcr.getDestinationClass(rc).getType();
		},

		preProcess: function() {
			// summary: open comment dialog to edit comment
			this.edit(this.getTitle(), {text: xml.nodeGetAttributeValue(this.getNode(), table.SPANNER_TEXT)});
		},

		preProcessContinue: function() {
			// summary: continue after editing comment
			this.process();
		},

		toWriter: function() {
			// summary: determine what to do based on new value - if no inner text, then delete it; otherwise create/edit it
			var s = this.commentValues.text.replace(html.INNERTEXT_REGEXP, "");
			if (s) {
				// create comment if not already created
				if (!this.m_bToggle) {
					this.inherited(arguments);
				}

				// set comment
				this.m_writer.changeNode(this.m_urlNode).changeAttribute(table.SPANNER_TEXT, xml.ATTR_STRING, this.commentValues.text);
			} else if (this.m_bToggle) {
				// delete comment
				this.inherited(arguments);
			}
		},

		postProcessSuccess: function() {
			// summary: refresh comment
			this.widget.postActionRefreshHierarchyRow(this);
		}
	});
});